import { get, put } from '@helsenorge/framework-utils/hn-tjeneste-service';

export const getAccessTokenExpiration = async (): Promise<{ Expire: string } | null> => {
  return get<{ Expire: string }>('/api/v1/AccessTokenExpiration');
};

export const putAccessTokenExpiration = async (): Promise<{ Expire: string } | null> => {
  return put<{ Expire: string }>('/api/v1/AccessTokenExpiration');
};

export default { getAccessTokenExpiration, putAccessTokenExpiration };
